<template>
    <div class="sustainable-component pot-salary-sum">
        <!--<div class="bg-success mb-3 p-3 rounded">vue component pot-salary-sum</div>-->
        <div class="container-fluid p-0">
            <div class="row">
                <div class="col-12">
                    Nyvarande lönesumma: <span v-decimal-text.max2="currentSalarySum"></span>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-12 col-md-8">
                    <div class="container-fluid p-0">
                        <div class="row">
                            <div class="col-12 col-md-6">
                                <v-text-field :decimal-sv="true" v-bind:disabled="disabled" bg-color="white"
                                              type="text"
                                              label="Ny lönesumma i kr"
                                              variant="outlined"
                                              v-model="newSalarySum"
                                              focused="true" @change="recalculatePercentage"></v-text-field>
                            </div>
                            <div class="col-12 col-md-1 pt-md-3 pb-5 pb-md-3 text-center">
                                eller
                            </div>
                            <div class="col-12 col-md-3">
                                <v-text-field :decimal-sv="true" v-bind:disabled="disabled" bg-color="white"
                                              type="text"
                                              label="Ökning i procent"
                                              variant="outlined"
                                              v-model="newSalarySumPercentage"
                                              focused="true" @change="recalculateNewSalarySum"></v-text-field>
                            </div>
                        </div>
                    </div>




                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    Nollställ/initiera nya värden i löneutrymmet i samband med att summan sparas.<br />
                    Detta görs oftast bara första gången pottfördelning används.<br />
                    <v-checkbox density="compact" v-model="resetValue" label="Nollställ/initiera" hide-details></v-checkbox>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-12">
                    <v-btn v-bind:disabled="disabled" variant="tonal" class="bg-primary" @click="saveValues">
                        Spara
                    </v-btn>
                </div>
            </div>
        </div>
        <v-snackbar :timeout="2000" v-model="showSnackBar" color="success">
            {{snackbarMessage}}
        </v-snackbar>
        <v-snackbar :timeout="2000" v-model="showErrorMessageSnackBar" color="error">
            {{errorMessage}}
        </v-snackbar>
        <common-spinner v-bind:loading="loading > 0"></common-spinner>
    </div>
</template>

<script>

    import AdminService from "../../Services/AdminService";
    import WageService from "../../Services/WageService";
    import { getCurrentInstance } from 'vue'
    import CommonSpinner from '../../common/common-spinner.vue'

    export default {
        emits: ['updated'],
        name: 'pot-salary-sum',
        components: {
            CommonSpinner
        },
        props: {
            disabled: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        methods: {
            getId() {
                return getCurrentInstance().uid;
            },
            recalculatePercentage() {
                var newSum = this.getInputNewSum();
                var percent = this.getPercentage(newSum, this.currentSalarySum);
                this.newSalarySumPercentage = percent.toString().replace(".",",");
            },
            recalculateNewSalarySum() {
                var tmpPercentage = this.getInputPercentage();
                var newSalarySum = this.getNewSalarySumFromPercentage(this.currentSalarySum, tmpPercentage);
                this.newSalarySum = newSalarySum;
            },
            getInputNewSum() {
                return parseFloat(this.newSalarySum.toString().replace(",", "."));
            },
            getInputPercentage() {
                return parseFloat(this.newSalarySumPercentage.replace(",", "."));
            },
            async saveValues() {
                this.loading++;
                try {
                    var newSum = this.getInputNewSum();
                    var tmpPercentage = this.getInputPercentage();
                    if (this.currentSalarySum == 0) {
                        alert("Nuvarande lönesumma är 0")
                        this.loading--;
                        return;
                    }

                    if (tmpPercentage <= 0 || newSum <= 0) {
                        alert("Ny lönesumma är för lågt")
                        this.loading--;
                        return;
                    }
                    await WageService.setPotSalarySum(newSum, this.resetValue);
                    this.reload();
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async loadCurrentVirtualCompany() {
                this.loading++;
                try {
                    var company = await AdminService.getCurrentVirtualCompany();
                    this.newSalarySum = company.PotSalarySum
                    if (this.newSalarySum == 0)
                        this.resetValue = true;
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            getAsSwedishNumberString(val) {
                var stringVal = val.toString().replace(".", ",");
                return stringVal;
            },
            async loadPotDistribution() {
                this.loading++;
                try {
                    var result = await WageService.getPotDistribution()
                    this.currentSalarySum = result.Salary;
                    if (result.Salary > 0 && this.newSalarySum > 0) {
                        var percent = this.getPercentage(this.newSalarySum, result.Salary);
                        this.newSalarySumPercentage = percent.toString().replace(".", ",");
                    }
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
                
            },
            getPercentage(newSalary, oldSalary) {
                var percentage = 0;
                percentage = ((newSalary - oldSalary) / oldSalary) * 100
                percentage = Math.round((percentage) * 100) / 100;
                return percentage;
            },
            getNewSalarySumFromPercentage(oldSalary, percent) {
                var sum = 0;
                sum = oldSalary * (1 + (percent / 100));
                return Math.round(sum);
            },
            reload() {
                this.loading++;
                try {
                    this.loadCurrentVirtualCompany();
                    this.loadPotDistribution();
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            displaySnackBar(message) {
                this.snackbarMessage = message;
                this.showSnackBar = true;
            },
            displayErrorSnackBar(message) {
                this.errorMessage = message;
                this.showErrorMessageSnackBar = true;
            },
        },
        data() {
            return {
                currentSalarySum: 0,
                newSalarySum: 0,
                resetValue: false,
                newSalarySumPercentage: "0",
                loading: 0,
                showSnackBar: false,
                snackbarMessage: null,
                showErrorMessageSnackBar: false,
                errorMessage: null,
            };
        },
        watch: {
           
        },
        mounted() {
            this.reload();
        },

        // eslint-disable-next-line
        setup(props, { emit }) {}

    }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    

</style>
